<template>
  <vh-dialog :visible="visible" width="580px" :before-close="handleClose">
    <h3 slot="title" class="dialog-title">
      分享
      <a href="javaScript:void(0);" v-if="btn_invite" class="link" @click="toInviteSetting">
        邀约海报设置
      </a>
    </h3>
    <div class="share-modal-content">
      <div class="link-section">
        <vh-form label-width="54px">
          <vh-form-item label="观看页">
            <vh-input
              id="link-input"
              class="link-input"
              v-model="watchUrl"
              readonly
              placeholder="观看页链接"
            ></vh-input>
            <vh-button
              type="text"
              class="copy-link"
              data-clipboard-target="#link-input"
              @click="copyLink('copy-link')"
            >
              复制
            </vh-button>
            <vh-button type="text" @click="openLink">打开</vh-button>
            <p class="tip-text">当前地址非嵌入使用 , 请前往「嵌入方式」获取嵌入链接</p>
          </vh-form-item>
        </vh-form>
      </div>
      <div class="qr-code-section">
        <div class="qr-item">
          <QrViewer
            title="H5观看"
            width="140px"
            height="140px"
            class="qr-viewer-custom"
            :state="watchShortState"
            :shortLinkUrl="watchShortUrl"
            @onRefresh="handleQrRefresh"
            @onDownload="downloadH5QrCode"
          />
        </div>
        <div class="qr-item" v-if="miniProgramQrCodeSrc">
          <h4>小程序观看</h4>
          <img :src="miniProgramQrCodeSrc" alt="小程序观看二维码" class="qr-code-img" />
          <vh-button round type="primary" size="medium" @click="downloadMiniProgramQrCode">
            下载二维码
          </vh-button>
        </div>
      </div>
    </div>
  </vh-dialog>
</template>

<script>
  import QrViewer from '@/components/QrViewer';
  import shortLinkHelper from '@/utils/shortLinkHelper';
  import { locationDownloadImage, isEmbed, randomNum } from '@/utils/utils';
  import to from 'await-to-js';
  import EventBus from '@/utils/Events';

  export default {
    name: 'ShareModal',
    components: {
      QrViewer
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      userId: {},
      webinar: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        watchUrl: '', // 观看页链接
        miniProgramQrCodeSrc: '', // 小程序观看二维码图片地址,
        watchPollingKey: 'general_watch' + randomNum(1, 10000),
        watchShortUrl: '', // 通用观看短链接
        watchShortState: 'doing' // 短链生成状态
      };
    },
    computed: {
      miniprogram_watch() {
        return !isEmbed() && this.$store.state.permission.miniprogram_watch == 1;
      },
      btn_invite() {
        return this.$store.state.permission.btn_invite == 1;
      }
    },
    beforeDestroy() {
      EventBus.$off('short_link_progress', this.handleShortLink);
    },
    methods: {
      init() {
        this.watchUrl = `${window.domainOfWatch()}/lives/watch/${this.webinar.webinar_id}`;

        EventBus.$on('short_link_progress', this.handleShortLink);
        this.takeShortLink();
        this.miniprogram_watch && this.getMiniprogramQrImage();
      },
      // 短链事件监听处理
      handleShortLink(result) {
        console.log('handleShortLink result:', JSON.stringify(result));
        if (!result || !result.longUrl || !result.pollingKey) return;
        switch (result.pollingKey) {
          case this.watchPollingKey:
            // 通用观看链接
            this.watchShortState = result.state;
            if (result.state === 'doing') {
              // this.watchShortTip = '短链接生成中，生成期间您可先使用原链接';
            } else if (result.state === 'success') {
              this.watchShortUrl = result.validShortUrl;
              // this.watchShortTip = '';
              // this.watchShortTip = '✅ 短链接已生成，可直接使用';
            } else if (result.state === 'failed') {
              // this.watchShortTip = '短链接生成失败，可继续使用原链接';
            }
            break;
        }
      },
      // 观看链接使用短连接处理
      async takeShortLink() {
        console.log('this.watchPollingKey:', this.watchPollingKey);
        const options = { origin: 'watch_link', description: this.webinar.subject || '' };
        const shortRlt = await shortLinkHelper.getShortLink(
          this.watchUrl,
          options,
          this.watchPollingKey
        );
        // console.log('shortRlt:', shortRlt);
        if (shortRlt?.status === 1 && shortRlt.validShortUrl) {
          this.watchShortUrl = shortRlt.validShortUrl;
        }
      },
      handleQrRefresh() {
        this.takeShortLink();
      },
      toInviteSetting() {
        const { webinar_id, webinar_type, webinar_state, vss_room_id, no_delay_webinar } =
          this.webinar;
        this.$router.push({
          path: '/live/invCard/' + webinar_id,
          query: {
            type: webinar_type,
            state: webinar_state,
            roomId: vss_room_id,
            isDelay: no_delay_webinar
          }
        });
      },
      handleClose() {
        this.$emit('update:visible', false);
      },
      copyLink(linkClass) {
        // 复制
        let clipboard = new this.$clipboard(`.${linkClass}`);
        clipboard.on('success', e => {
          this.$vhMessage({
            message: `复制成功`,
            showClose: true,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          e.clearSelection();
          clipboard.destroy();
        });
        clipboard.on('error', e => {
          this.$vhMessage({
            message: `复制失败`,
            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          clipboard.destroy();
        });
      },
      openLink() {
        // 打开链接逻辑
        window.open(this.watchUrl, '_blank');
      },

      // 获取小程序二维码
      async getMiniprogramQrImage() {
        // https://developers.weixin.qq.com/miniprogram/dev/OpenApiDoc/qrcode-link/qr-code/getUnlimitedQRCode.html#%E8%B0%83%E7%94%A8%E6%96%B9%E5%BC%8F
        // 小程序的版本:release,trial,develop,默认release
        let env_version = this.$route.query?.env_version;
        if (!env_version && process.env.VUE_APP_ENV === 'test') {
          // 测试环境默认体验版
          env_version = 'trial';
        }
        const params = {
          biz_id: process.env.VUE_APP_BIZ_ID || 2,
          biz_application_id: process.env.VUE_APP_APP_ID,
          business_uid: this.userId,
          page_path: 'pages/index/index',
          page_args: `s=1&wId=${this.webinar.webinar_id}`, // 长度不超过32个字符
          env_version: ['trial', 'develop'].includes(env_version) ? env_version : 'release'
        };
        const [err, res] = await to(
          this.$fetch('getMiniprogramQrImage', params, {
            'Content-Type': 'application/json'
          })
        );
        if (err || !res || res.code != 200 || !res.data) {
          this.$vhMessage.error(err?.msg || res?.msg || '请求失败');
          return;
        }
        this.miniProgramQrCodeSrc = res.data.qr_image;
      },
      // 下载小程序二维码
      downloadMiniProgramQrCode() {
        locationDownloadImage(this.miniProgramQrCodeSrc, {
          name: `${this.webinar.subject || 'code'}小程序二维码.png` // 设置图片名称
        });
      },
      downloadH5QrCode(qrUrl) {
        locationDownloadImage(qrUrl, {
          name: `${this.webinar.subject || 'code'}观看端二维码.png` // 设置图片名称
        });
      }
    },
    created() {
      this.init();
    }
  };
</script>

<style scoped lang="less">
  .dialog-title {
    font-weight: 600;
    font-size: 18px;
    a {
      margin-left: 10px;
      font-size: 14px;
    }
  }
  .link-section {
    margin-bottom: 20px;
    .link-input {
      width: calc(100% - 86px);
      margin-right: 10px;
    }
  }
  .tip-text {
    font-size: 12px;
    line-height: 30px;
  }
  .qr-code-section {
    display: flex;
    justify-content: space-around;
    padding-bottom: 10px;
  }
  .qr-item {
    text-align: center;
  }
  .qr-code-img {
    width: 140px;
    height: 140px;
    margin: 10px 0;
    display: block;
  }
  ::v-deep .qr-viewer-custom {
    .qr-viewer__hd .qr-viewer-title {
      line-height: 1;
      margin-bottom: 10px;
    }
  }
</style>
